/** Placeholder fallbacks when tenant API returns no data. Indicates where tenant-configured values will appear. */
export const CONTACT_DATA = {
  logo: "",
  name: "Tenant name",
  website: "https://tenantname.com",
  address: "Street address",
  city: "City",
  postalCode: "ZIP / Postal code",
  phone: "Phone number",
} as const;
